/**
 * @format
 * @Description: Header导航状态机
 * @Autho: 人杰
 * @Date:2019/10/18 11:47
 */

import { observable, action, computed, useStrict } from 'mobx';
useStrict(true);
class HeaderGlobalMod {
  /** 导航数据源 */
  @observable
  dataSource = [];

  @observable
  dataSourceSelect = {};

  @observable
  iframeId = 'systemIframe'

  @action
  updateDataSource({ dataSource = [], reset }) {
    if (reset) {
      this.dataSource = [];
      this.dataSourceSelect = {};
      return;
    }
    dataSource.forEach(item => {
      let index = this.dataSource.findIndex(item1 => item.eventKey == item1.eventKey);
      if (item.type == 'Change') {
        if (index != -1) {
          this.handleClickNav(this.dataSource[index], String(item.title), true);
        }
      } else {
        if (index == -1) {
          this.dataSource.push(item);
          if (item.type == 'Select') {
            this.dataSourceSelect[item.eventKey] = item.children[0].eventKey;
          }
          if (item.type == 'Tree') {
            this.dataSourceSelect[item.eventKey] = item.children[0].name;
          }
        } else {
          this.dataSource[index] = item;
          if (item.type == 'Select') {
            this.dataSourceSelect[item.eventKey] = item.children[0].eventKey;
          }
          if (item.type == 'Tree') {
            this.dataSourceSelect[item.eventKey] = item.children[0].name;
          }
        }
      }
    });
    //console.log(51,'dataSourceSelect',this.dataSourceSelect)
  }

  @action
  handleClickNav(item, val, noNeedPost) {
    let iframe = document.getElementById(this.iframeId);
    let dataSource = {};
    dataSource.eventKey = item.eventKey;
    let dataSourceSelect = JSON.parse(JSON.stringify(this.dataSourceSelect));
    if (item.type == 'Select' || item.type == 'Change' || item.type == 'Tree') {
      dataSourceSelect[item.eventKey] = val;
      this.dataSourceSelect = dataSourceSelect;
      dataSource.children = item.children.find(children => children.eventKey == val);
      if (item.type == 'Tree') {
        dataSource.children = [{ id: val }];
      }
    }
    if (item.type == 'custom-service') {
      dataSource.eventKey = val;
    }
    if (!noNeedPost && iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage({ eventKey: item.eventKey, dataSource: dataSource }, '*');
    }
  }
}

// ES6单例写法
export default new HeaderGlobalMod();



// WEBPACK FOOTER //
// ./src/widget/HeaderGlobal/HeaderGlobalMod.js